import styled from 'styled-components';

export const AboutSection = styled.section`
    background: url('images/About/about-bg.jpg') no-repeat;
    background-size: cover;
    background-attachment: fixed;
    height: 600px
`